import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type Video = {
  source: string;
  contentType: 'video/mp4';
  captionsFile: string;
  ariaDescribedby: string;
};

export function Video({ source, contentType, captionsFile, ariaDescribedby }: Video) {
  const { t } = useSonTranslation('Video');
  return (
    <div className="video">
      {/* unfortunately track is optional (PO decision) */}
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video className="video__element" controls aria-describedby={ariaDescribedby}>
        <source src={source} type={contentType} />
        {captionsFile && <track default src={captionsFile} kind="captions" srcLang="de" label={t('german')} />}
      </video>
    </div>
  );
}
